
window.ListingController = class {
	constructor(options = {}) {
		this.tpl = $('#page');
		this.options = options;
	}

	initialized = false;
	async init(options = {}) {
		const self = this;

		if(self.initialized) {
			return;
		}
		self.initialized = true;

		// Bind de los triggers
		self.tpl.on('click', '[data-trigger^="Listing."]', function(event){

			const target = event.currentTarget;

			if(target.dataset.allowPropagation === undefined) {
				event.stopPropagation();
			}

			switch(target.dataset.trigger) {
				case 'Listing.loadMore':
					self.loadMore(target);
					break;
			}
		});

		// en IOS el scroll de videos funciona bien, es principalmente en Android de gama media y baja que afecta mucho, los gama alta tbn son afectados en menor medida.
		if(UtilityHelper.isMobile() && !UtilityHelper.isMobile('iOS')) {
			self.improveVideoScroll();
		}

		self.initCovers();

		self.initSearch();

		self.loadVideos();

		self.initDynamicContent();

		// Inicializar las historias
		const $storyElements = this.tpl.find('.listing-type-story[data-plugin="story"]');
		for(const storyElement of $storyElements) {
			new StoryComponent(storyElement);
		}

		FavListHelper.listingOnChange();
	}


	loadedVideos = [];
	initCovers() {
		const self = this;
		const coverIntersection = new IntersectionObserver((entries, observer) => {
			const self = this;
			for(let entry of entries) {
				let player = entry.target;
				if(entry.isIntersecting) {

					if( self.loadedVideos.indexOf(player) == -1) {
						if( self.loadedVideos.length > 30 ) {
							for(let i = 0; i < 10; i++) {
								let src = self.loadedVideos[i].src;
								self.loadedVideos[i].removeAttribute('src');
								self.loadedVideos[i].load();
								self.loadedVideos[i].setAttribute('src', src);
							}
							self.loadedVideos.splice(0, 10);
						}
						self.loadedVideos.push(player);
					}

					player.dataset.loaded = true;
					player.dataset.play = true;
					player.muted = true;

					if( player.readyState >= 2 ) {
						if( self.isScrolling == false )
							var playPromise = player.play();
							if (playPromise !== undefined) {
								playPromise.catch(error => {
									console.warn('Error al intentar reproducir el video:', error);
								});
							}
					}
					else {
						player.load();
						player.onloadeddata = (event) => {
							if(player.readyState >= 2) {
								var playPromise = player.play();
								if( self.isScrolling != false && playPromise !== undefined ) {
									playPromise.then(() => {
										if (!player.paused) {
											player.pause();
										}
									}).catch(error => {
										console.warn('Error al intentar reproducir el video:', error);
									});
								}
							}
						};
					}

				} else {
					player.dataset.play = false;
					if( player.dataset.loaded == 'true' ) {
						let playPromise = player.play();
						if (playPromise !== undefined) {
							playPromise.catch(error => {
								console.warn('Error al intentar reproducir el video:', error);
							});
						}
					}
				}
			}
		}, {
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: 0,
		});
		if(!(UtilityHelper.isMobile('Android') && UtilityHelper.getAndroidVer() < 8)) {
			for(let item of document.querySelectorAll(".listing-video:not([data-observing])")) {
				item.dataset.observing = true;
				coverIntersection.observe(item);
			}
		}
	}

	initSearch() {
		const self = this;
		const searchBar = self.tpl.find('#show_search_bar');

		if( searchBar ) {
			searchBar.on('click', async (event) => {
				await Library.load(['jsCookie']);
				Cookies.set('show_search_bar', event.currentTarget.classList.contains('collapsed')? 0 : 1, { expires: 7 })
			});
		}

		var staticData;
		var regionData;
		var $searchEscort;
		var $searchRegion;

		self.tpl.find("#searchRegion").on('click', async function() {
			let [res] = await Promise.all([
				regionData? null : fetch(`${NOW.settings.url_api}/regions/${self.options.region_country}`),
				Library.load(['select2','select2region']),
			]);


			if( !regionData ){
				regionData = await res.json();
				Cache.Region = new CollectionHelper('id', regionData);
				let $select = $(this).find('select');
				$searchRegion = await $select.select2region({
					insertInputs: false,
					theme: 'default select2-escorts select2-escorts-region',
				});

				$select.on('change', function (e) {
					window.location = `${NOW.settings.url_region}/${Cache.Region.get($(this).val(), 'region_url')}`;
				});

			}
			$searchRegion.s2inst.select2('open');
		});

		self.tpl.find("#searchEscort").on('click', async function() {

			let [res] = await Promise.all([
				staticData? null : fetch(`/api/fetch/static`),
				Library.load(['select2']),
			]);

			// Define la función para hacer la solicitud con axios
			function fetchPubs(params) {
				// Prepara los datos de búsqueda
				const queryParameters = {
					search: params.term
				};

				// Usa axios para hacer la solicitud POST
				return axios.post(`/api/fetch/pubs/${self.options.region_id}`, queryParameters, {
					headers: {
						'Content-Type': 'application/json; charset=utf-8'
					}
				})
				.then(response => {
					return {
						results: response.data // Devuelve el formato esperado por select2
					};
				});
			}

			if(!staticData) {
				staticData = await res.json();
				$searchEscort = $(this).find('select').select2({
					minimumInputLength: 3,
					ajax: {
						transport: function (params, success, failure) {
							fetchPubs(params.data)     // Pasa solo params.data
								.then(success)
								.catch(failure);
						},
						delay: 500 // Añade un retraso para limitar las llamadas
					},
					templateResult: function(pub) {
						if(!pub.pub_id) return pub;

						let template = `
							<div class="d-flex align-items-center">
								<picture class="avatar avatar-md mr-10 flex-shrink-0">
									<img	src="${NOW.settings.url_media}/${pub.pub_id}/avatar.jpg?${pub.pub_cover_mod}"
											data-fallback="${NOW.settings.url_assets}/images/default.png"
											class="object-fit" />
								</picture>
								<div>
									<h5 class="mb-0 font-size-14">${pub.pub_title}</h5>
									<div class="font-size-12">${pub.pub_province_name || '' } ${pub.pub_city_name || ''} ${pub.pub_zone_name || ''}</div>
									<div class="d-flex align-items-center flex-wrap">`;

									for(let category of UtilityHelper.split(pub.pub_category)){
										//template += `<div class="badge badge-accent mr-5 mb-5">${staticData[category].term_name || ''}</div>`;
									}

						template += `
									</div>
								</div>
							</div>`;


						var $html = $(template);
						return $html;
					},
					theme: 'default select2-escorts',
					escapeMarkup: function (markup) {
						return markup;
					},
				});

				$searchEscort.on('select2:select', function (e) {
					var data = e.params.data;
					window.location = `${NOW.settings.url_region}/${data.pub_slug}`;
				});
			}

			$searchEscort.select2('open');
			self.tpl.find(".select2-search__field").focus();
		});
	}

	initDynamicContent() {
		const self = this;

		// Observer Scroll vertical para carga dinamica
		let obInfiniteScroll = new IntersectionObserver(self.infinityScroll.bind(self), {
			root: null,
			rootMargin: '400px 0px 400px 0px',
			threshold: 0,
		});
		for(let pagination of self.tpl.find('.pagination[data-plugin="infinity_scroll"]:not([data-block_type="scroll"]), .pagination[data-plugin="infinity_scroll_extreme"]')) {
			if( parseInt(pagination.dataset.start) < parseInt(pagination.dataset.end) ){
				obInfiniteScroll.observe(pagination);
			}
		}

		// Observar Scroll horizontal de cada bloque, para carga dinamica
		for(let pagination of self.tpl.find('.pagination[data-plugin="infinity_scroll"][data-block_type="scroll"]')) {
			let obInfiniteScroll2 = new IntersectionObserver(self.infinityScroll.bind(self), {
				root: UtilityHelper.isMobile()? pagination.parentElement : pagination.parentElement.parentElement,
				rootMargin: '0px 400px 0px 400px',
				threshold: 0,
			});
			if( parseInt(pagination.dataset.start) < parseInt(pagination.dataset.end) ){
				obInfiniteScroll2.observe(pagination);
			}
		}

		// Observer Scroll vertical de Widgets para carga dinamica
		let obInfiniteScrollWidget = new IntersectionObserver(self.infinityScrollWidget.bind(self), {
			root: null,
			rootMargin: '400px 0px 400px 0px',
			threshold: 0,
		});
		for(let pagination of self.tpl.find('div[data-plugin="widget"]')) {
			obInfiniteScrollWidget.observe(pagination);
		}
	}

	// En mobile al scrollear pausa los videos de los covers para mejorar la experiencia al scrollear.
	isScrolling = false;
	improveVideoScroll() {
		const self = this;
		// Listen for scroll events
		window.addEventListener('scroll', UtilityHelper.throttle( 20, function ( event ) {

			// Si no estaba scrolleando, ahora lo esta. Hay que pausar los videos.
			if( self.isScrolling == false ) {
				for(let video of document.querySelectorAll('video[data-play="true"]')) {
					let playPromise = video.play();
					if (playPromise !== undefined) {
						playPromise.then(() => {
							if (!video.paused) {
								video.pause();
							}
						}).catch(error => {
							console.warn('Error al intentar pausar el video:', error);
						});
					}
				}
			}

			// Resetear el timeout. Mientras scrollea este proceso se repite para impedir que comiencen los videos
			window.clearTimeout( self.isScrolling );

			// Si dispara el timeout, es porque dejo de scrollear. Hay que reproducir los videos
			self.isScrolling = setTimeout(function() {
				self.isScrolling = false;
				for(let video of document.querySelectorAll('video[data-play="true"]')) {
					let playPromise = video.play();
					if (playPromise !== undefined) {
						playPromise.catch(error => {
							console.warn('Error al intentar reproducir el video:', error);
						});
					}
				}
			}, 100);

		}), false);
	}

	async loadVideos() {
		const self = this;

		let list = self.tpl.find('.section-listing[data-plugin="video"]');
		if(list.length) {
			await Library.load("magnificPopup");
		}
		for(let gallery of  list) {
			$(gallery).magnificPopup({
				delegate: 'a.video__link',
				mainClass: 'fade show',
				type: 'inline',
				//preload: [5,5],
				gallery:{
					enabled:true,
					navigateByImgClick: true,
				},
				//preloader: false,
				callbacks: {
					open: function() {
						var mfp = $.magnificPopup.instance;
						var proto = $.magnificPopup.proto;

						$('.mfp-container').addClass('mfp-image-holder').removeClass('mfp-inline-holder');
						$(".mfp-container").swipe({
							swipeLeft: function(event, direction, distance, duration, fingerCount) {
								$.magnificPopup.instance.next();
							},
							swipeRight: function(event, direction, distance, duration, fingerCount) {
								$.magnificPopup.instance.prev();
							},
						});
						// extend function that moves to next item
						mfp.next = function() {

							// if index is not last, call parent method
							if(mfp.index < mfp.items.length - 1) {
								proto.next.call(mfp);
							} else {
							// otherwise do whatever you want, e.g. hide "next" arrow
							}
						};

						// same with prev method
						mfp.prev = function() {
							if(mfp.index > 0) {
								proto.prev.call(mfp);
							}
						};

						for( let item of $.magnificPopup.instance.ev[0].querySelectorAll('.video__link:not([data-loaded])') ) {
							item.dataset.loaded = true;
						}
					},
					// si tiene un video, lo pauso.
					beforeClose: function() {
						let vid = $('.mfp-container').find('video');
						if( vid.length > 0) {
							vid[0].pause();
						}
					},
					afterClose: function() {
						// Dot removes the entire query string; you may want to rewrite this to
						// remove only necessary parts of the query string
						if(location.search.length) {
							let query = location.toString().replace(location.search, "");
							window.history.pushState({query: query}, '', query);
						}

					},

					change: function(item) {

						let selfie = this;

						// scrollear al elemento para activar el infiniteload
						selfie.currItem.el[0].scrollIntoView();

						if(this.gallery_content_prev != null){
							let vid = this.gallery_content_prev.find('video');
							if( vid.length ){
								vid[0].pause();
								// Ayudar a liberar memoria para que no cuelgue el celu
								let src = vid.attr('src');
								vid[0].removeAttribute('src');
								vid[0].load();
								vid.attr('src', src);

							}
						}
						selfie.gallery_content_prev = selfie.content;

						let player = selfie.content[0].querySelector('video');
						let index = selfie.index;
						// player.play();
						if( player ) {
							if( player.readyState >= 2 ) {
								player.play();
							}
							else {
								player.load();
								player.onloadeddata = (event) => {
									if(player.readyState >= 2 && index == $.magnificPopup.instance.index) {
										player.play();
									}
								};
							}
						}
					} // change
				}
			});
		}
	}

	updateVideos(section) {

		const self = this;

		if( !$.magnificPopup || !$.magnificPopup.instance.items ) return;
		let instance = $.magnificPopup.instance;
		if( $.magnificPopup.instance.isOpen && section.id == $.magnificPopup.instance.ev[0].id ) {
			instance.items.push(...instance.ev[0].querySelectorAll('.video__link:not([data-loaded])'));
			instance.updateItemHTML();
		}
	}

	// carga dinamica de los widgets, la implementacion es similar al scroll infinity pero el request es diferente
	infinityScrollWidget(entries, observer) {
		const self = this;

		async function load(pagination) {
			var response = fetch(pagination.dataset.api + '/' + pagination.dataset.id, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(pagination.dataset)
			})
			.then(function (response) {
				// The API call was successful!
				return response.text();
			}).then(function (html) {
				if(html.length > 50) {
					pagination.classList.add('widget-showing');
				}
				pagination.insertAdjacentHTML('afterbegin', html);
				NOW.Page.loadPlugins($(pagination));

			}).catch(function (err) {
				// There was an error
				console.warn('Something went wrong.', err);
			});
		}

		for(let entry of entries) {

			let pagination = entry.target;
			if(entry.isIntersecting) {
				load(pagination);
				// una vez cargado detener seguimiento
				observer.unobserve(pagination);
			}
		}
	}

	infinityScroll (entries, observer) {
		const self = this;

		async function load(pagination) {
			pagination.dataset.loading = true;

			let block_id = pagination.dataset.block_id;
			let section = document.getElementById('block-' + block_id);
			let start = parseInt(pagination.dataset.start);
			let end = parseInt(pagination.dataset.end);
			pagination.dataset.start = parseInt(pagination.dataset.start) + 1;

			// Si llego al final, detener seguimiento
			if( start + 1 >= end ){
				observer.unobserve(pagination);
			}

			let loadCount = start * parseInt(pagination.dataset.iteration) + parseInt(pagination.dataset.iteration) > parseInt(pagination.dataset.total)
								? parseInt(pagination.dataset.total) - start * parseInt(pagination.dataset.iteration)
								: parseInt(pagination.dataset.iteration);
			section.querySelector('.listing-additional').insertAdjacentHTML('beforebegin',
			`<div class="listing-pub" data-block_id="${block_id}" data-pagination-loading="${start}">
				<div class="cover">
					<div class="listing-image">
						<div class="lds-ring absolute-center"><div></div><div></div><div></div><div></div></div>
					</div>
				</div>
			</div>`.repeat(loadCount));

			// actualizar contador de childs incluyendo los de Loading
			$(section).css('--elements-count', $(section).children().length || 0);

			// Obtener contenido
			const response = await fetch(`/api/fetch/block/${block_id}/${start}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(pagination.dataset)
			});
			const newContent = await response.text();

			// Insertar contenido
			section.querySelector('.listing-additional').insertAdjacentHTML('beforebegin', newContent);
			// Remove contenido Loading
			document.querySelectorAll(`.listing-pub[data-block_id="${block_id}"][data-pagination-loading="${start}"]`).forEach((elem) => elem.remove());
			// volver a actualizar contador de childs
			$(section).css('--elements-count', $(section).children().length || 0);
			// actualizar video covers
			self.initCovers();
			self.updateVideos(section);
			FavListHelper.listingOnChange(section);
			pagination.dataset.loading = false;

			// La paginacion SCROLL de tipo infinite_scroll_extreme debe cambiar el tipo de observacion al realizar la 1ra carga.
			if( pagination.dataset.plugin == "infinity_scroll_extreme" && pagination.dataset.block_type == 'scroll' && start == 0) {
				observer.unobserve(pagination);
				let options = {
					root: UtilityHelper.isMobile()? pagination.parentElement : pagination.parentElement.parentElement,
					rootMargin: '0px 400px 0px 400px',
					threshold: 0,
				};
				let newObserver = new IntersectionObserver(self.infinityScroll.bind(self), options);
				newObserver.observe(pagination);
			}
		}

		for(let entry of entries) {

			let pagination = entry.target;
			if(entry.isIntersecting && pagination.dataset.loading != true) {

				// Si llego al final, detener seguimiento
				if( parseInt(pagination.dataset.start) >= parseInt(pagination.dataset.end) ){
					observer.unobserve(pagination);
					return;
				}

				load(pagination);

			}
		}
	}

	// Carga dinamica disparada por button:click
	async loadMore(target) {

		const self = this;

		async function load(pagination) {
			let block_id = pagination.dataset.block_id;
			let section = document.getElementById('block-' + block_id);
			pagination.dataset.loading = true;

			let loadCount = parseInt(pagination.dataset.start) * parseInt(pagination.dataset.iteration) + parseInt(pagination.dataset.iteration) > parseInt(pagination.dataset.total)
								? parseInt(pagination.dataset.total) - parseInt(pagination.dataset.start) * parseInt(pagination.dataset.iteration)
								: parseInt(pagination.dataset.iteration);
			section.querySelector('.listing-additional').insertAdjacentHTML('beforebegin',
			`<div class="listing-pub" data-block_id="${block_id}" data-pagination-loading="${pagination.dataset.start}">
				<div class="cover">
					<div class="listing-image">
						<div class="lds-ring absolute-center"><div></div><div></div><div></div><div></div></div>
					</div>
				</div>
			</div>`.repeat(loadCount));

			// Obtener contenido
			const response = await fetch(`/api/fetch/block/${block_id}/${pagination.dataset.start}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(pagination.dataset)
			});
			const newContent = await response.text();

			// Insertar contenido
			section.querySelector('.listing-additional').insertAdjacentHTML('beforebegin', newContent);
			// Remove contenido Loading
			document.querySelectorAll(`.listing-pub[data-block_id="${block_id}"][data-pagination-loading="${pagination.dataset.start}"]`).forEach((elem) => elem.remove());
			// actualizar contador de childs
			$(section).css('--elements-count', $(section).children().length || 0);
			// actualizar video covers
			self.initCovers();
			self.updateVideos(section);
			FavListHelper.listingOnChange(section);
			pagination.dataset.loading = false;

			pagination.dataset.start = parseInt(pagination.dataset.start) + 1;
		}

		let pagination = target.parentNode;
		await load(pagination);

		if(parseInt(pagination.dataset.start) > parseInt(pagination.dataset.end)) {
			target.remove();
		}

	}
};